import invoiceList from "dummydata/invoiceList";
import { INVOICE_TOTAL } from "redux/actionTypes/actionTypes";
import { DELETE_INVOICE } from "redux/actionTypes/actionTypes";
import { ADD_INVOICE,GET_INVOICE_LIST } from "redux/actionTypes/actionTypes";

const initialState = {
  invoiceList: [],
  invoiceTotal: 0,
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVOICE_LIST:
      return {
        ...state,
        invoiceList: action.payload,
      };
      break;
    case ADD_INVOICE:
      return {
        ...state,
        invoiceList: state.invoiceList.concat(action.payload),
      };
      break;
    case DELETE_INVOICE:
      return {
        ...state,
        invoiceList: state.invoiceList.filter(
          (item) => !action.payload.includes(item.key)
        ),
      };
      break;
    case INVOICE_TOTAL:
      return {
        ...state,
        invoiceTotal: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};
export default invoiceReducer;
